module.exports = __webpack_public_path__ + "static/media/RAY_transparent_logo.b7717d3c.png";